export class SizeAdapter {
  static toOutputDTO(res: any[]): number {
    const sorted = res
      .sort(
        (a, b) =>
          new Date(b.upload_at).getTime() - new Date(a.upload_at).getTime()
      );

    let size: number = 0;
    for (const item of sorted) {
      if (item.status == 1) {
        size += item.size
      }
      if (item.store_type == "new" && item.status == 1) {
        break;
      }
    }
    return size;
  }
}
